// extracted by mini-css-extract-plugin
export default {"virtualized-diff-row":"PullRequestVirtualizedDiffsList-module__virtualized-diff-row--khMB_"};